import { Injectable } from '@angular/core';
import { CategoryCombo, TextFilter, HistoricalComboAthlete, CategorySearchCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { combineLatest, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FiltersAbstractService } from '../../../../common-page-components/classes/filters-abstract-service';
import {  Router } from '@angular/router';

/**
 * Provides filters for atheletes in a member association.
 *
 * @export
 * @class MembersAthletesFiltersServiceService
 * @extends {FiltersAbstractService}
 */
@Injectable({
  providedIn: 'root'
})
export class MembersAthletesFiltersServiceService extends FiltersAbstractService {
  countryCode = new BehaviorSubject('all');
  categoryCombo = new CategoryCombo('Categories:', 'categorycombo', this.http, [{ item: { Name: 'All' }, position: 0 }]);
  textFilter = new TextFilter('searchinput');
  activeCombo = new HistoricalComboAthlete('Current', 'currentcombo', undefined,
  [{ item: { Name: 'Active and inactive' }, position: 0 }, { item: { Name: 'Active' }, position: 1 }, { item: { Name: 'Inactive' }, position: 2 }]);
  filtersType: any = [
    this.textFilter.filterInfo,
    this.categoryCombo.filterInfo,
    this.activeCombo.filterInfo,
  ];


  /**
   * Creates an instance of MembersAthletesFiltersServiceService.
   *
   * @param {HttpClient} http
   * @memberof MembersAthletesFiltersServiceService
   */
  constructor(protected http: HttpClient, private router:Router) {
    super();
  }

  /**
   * {@inheritdoc}
   *
   * @memberof MembersSearchFiltersService
   */
  generateDefaultValues(): void {}

  /**
   * {@inheritdoc}
   *
   * @returns
   * @memberof MembersSearchFiltersService
   */
  getDataStreamWithFilters() {
    return combineLatest([this.orderValue,
    this.textFilter.data(),
    this.categoryCombo.comboData,
    this.activeCombo.comboData,
    this.countryCode.asObservable()
    ]);
  }
}
